
import { Star, CheckCircle } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { openGoogleCalendar } from "@/lib/utils";

const benefits = [
  "Plano alimentar 100% personalizado",
  "Acompanhamento online ou presencial",
  "Sem dietas restritivas ou radicais",
];

export function HeroSection() {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden bg-white pt-20">
      {/* Fundo verde escuro com corte diagonal lateral */}
      <div className="absolute inset-y-0 left-0 w-full md:w-[70%] bg-brand-primary hidden md:block"
        style={{ clipPath: "polygon(0 0, 78% 0, 100% 100%, 0 100%)" }} />
      {/* Mobile: fundo cheio */}
      <div className="absolute inset-y-0 left-0 w-full bg-brand-primary md:hidden" />

      <div className="relative container mx-auto px-6 grid md:grid-cols-2 gap-0 items-center min-h-screen">

        {/* Esquerda — copy */}
        <div className="py-20 md:py-0 pr-0 md:pr-16 space-y-8 z-10">
          {/* Badge de credencial */}
          <div className="inline-flex items-center gap-2 bg-white/15 border border-white/25 text-white/90 px-4 py-2 rounded-full text-xs font-bold font-primary tracking-wide uppercase">
            <Star className="w-3.5 h-3.5 fill-white text-white" />
            Nutricionista CRN 3/63492 · 6 anos de experiência
          </div>

          {/* Headline */}
          <div>
            <span className="title-special text-4xl md:text-5xl text-white/70 block leading-none mb-2">
              Transforme sua
            </span>
            <h1 className="text-5xl md:text-6xl font-extrabold text-white font-primary leading-[1.05]">
              relação com{" "}
              <span className="text-brand-softYellow">a comida.</span>
            </h1>
          </div>

          <p className="text-white/75 text-lg leading-relaxed font-primary font-light max-w-md">
            Acompanhamento nutricional humanizado para quem busca saúde de verdade. Sem restrições absurdas, sem culpa, com ciência e empatia.
          </p>

          {/* Benefícios */}
          <ul className="space-y-2">
            {benefits.map((b) => (
              <li key={b} className="flex items-center gap-2.5 text-white/85 text-sm font-primary">
                <CheckCircle className="w-4 h-4 text-brand-softYellow flex-shrink-0" />
                {b}
              </li>
            ))}
          </ul>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <button
              onClick={openGoogleCalendar}
              className="bg-brand-secondary hover:bg-[#d4691f] text-white font-bold font-primary rounded-full px-8 py-4 text-base transition-all duration-200 shadow-xl shadow-brand-secondary/40 hover:scale-105 flex items-center justify-center gap-2"
            >
              Agendar Avaliação Gratuita →
            </button>
            <a
              href="https://wa.me/5511998874081"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white/30 text-white hover:bg-white/10 font-bold font-primary rounded-full px-8 py-4 text-base transition-all duration-200 flex items-center justify-center gap-2"
            >
              <FaWhatsapp className="w-5 h-5" />
              Falar no WhatsApp
            </a>
          </div>

        </div>

        {/* Espaço reservado para a coluna direita no grid */}
        <div className="hidden md:block" />
      </div>

      {/* Foto preenchendo todo o lado direito */}
      <div className="absolute inset-y-0 right-0 w-[50%] hidden md:block">
        <img
          src="/camisa-preta.JPG"
          alt="Dra. Brenda Ramos - Nutricionista"
          className="w-full h-full object-cover object-top"
        />

        {/* Card flutuante — avaliação Google */}
        <div className="absolute left-6 top-24 bg-white rounded-2xl shadow-2xl px-5 py-4 border border-gray-100">
          <div className="flex gap-0.5 mb-1">
            {[1,2,3,4,5].map(i => <Star key={i} className="w-3.5 h-3.5 text-yellow-400 fill-current" />)}
          </div>
          <p className="text-xs font-bold text-gray-800 font-primary">5.0 no Google</p>
          <p className="text-xs text-gray-400 font-primary">100+ avaliações</p>
        </div>

        {/* Card flutuante — consultórios */}
        <div className="absolute right-8 bottom-20 bg-brand-secondary text-white rounded-2xl shadow-2xl px-5 py-4">
          <p className="text-2xl font-extrabold font-primary leading-none">3</p>
          <p className="text-xs font-primary text-white/80">Consultórios</p>
        </div>
      </div>
    </section>
  );
}
